import { Component, ViewChild } from '@angular/core';
import { Observable, Subject } from 'rxjs';
//import { LoadingBarService } from '@ngx-loading-bar/core';
import { Router, RouterLink } from '@angular/router';
import { RevenueManagementProperties } from '../Models/RevenueManagementProperties';
import { DxDataGridComponent, DxPopoverComponent, DxDataGridModule, DxPopoverModule } from 'devextreme-angular';
import { RevenueManagementService } from "../Services/revenue-management.service";
import { TicketPnrRights } from '../Models/TicketIssuanceProperties';
import { TicketIssuanceService } from '../Services/ticketIssuance.service';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { DxoScrollingModule, DxoPagingModule, DxoPagerModule, DxiColumnModule, DxoSearchPanelModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { FormsModule } from '@angular/forms';
declare var $;

@Component({
    selector: 'app-revenue-management-list',
    templateUrl: './revenue-management-list.component.html',
    styleUrls: ['./revenue-management-list.component.css'],
    imports: [NavMenuComponent, RouterLink, DxDataGridModule, DxoScrollingModule, DxoPagingModule, DxoPagerModule, DxiColumnModule, DxoSearchPanelModule, DxTemplateModule, FormsModule, DxPopoverModule]
})
/** RevenueManagementList component*/
export class RevenueManagementListComponent {
  @ViewChild(DxPopoverComponent) popOver: DxPopoverComponent;
  @ViewChild('revenueGrid') dataGrid: DxDataGridComponent;
  popoverTarget: any;
  popOverText: string;
  currentUrl: string;
  hideNavMenu: boolean;
  constructor(private ticketIssuanceService: TicketIssuanceService, private revenueService: RevenueManagementService, private router: Router, private messageService: MessageService, private confirmationService: ConfirmationService) {
    this.popoverTarget = "";
    this.popOverText = "hello shoaib";
  }

  revenueManagerList: RevenueManagementProperties[] = [];
  collapsed = false;
  showDeleteModal: boolean = false;
  selectedRevenueId: number | null = null;
  contentReady = (e) => {
    $(".dx-datagrid-headers").css({ "background-color": "white", "color": "#212529", "font-weight": "bold" });
    if (!this.collapsed) {
      this.collapsed = true;
      e.component.expandRow(["EnviroCare"]);
    }

  };

  onCellHoverChanged(e) {
   
    if (e.rowType === "data" && e.column.dataField === "agencyBranchList" && e.eventType === "mouseover") {
      
      this.popOverText = e.text;
      this.popoverTarget = e.cellElement;
      this.popOver.width = "auto";
      this.popOver.height = "auto";
      this.popOver.visible = true;
      this.popOver.position = "top";
      this.popOver.instance.show();
 
    }
    if (e.rowType === "data" && e.eventType === "mouseout") {
      this.popOver.instance.hide();
    }
  }
  tktPnrRight = new TicketPnrRights();
  right = false;
  canEditOrAddRevenue = false;
  fromLocalStorage: string;
  agency: number;
  ngOnInit() {
    this.getCurrentUrl();
    this.getrevenueRights();
    this.LoadAgencyList();
    this.CheckRevenueManagementRights();
    this.CheckCanEditRevenueRights();
   
  }
 


  getCurrentUrl(): void {
    this.currentUrl = this.router.url;
    if (this.router.url === "/agencyMaster") {
      this.hideNavMenu = false;
      this.fromLocalStorage = localStorage.getItem("forAgencyMaster");
      this.agency = 1;
    }
    else {
      this.hideNavMenu = true;
      this.fromLocalStorage = localStorage.getItem("AgencyId");
      this.agency = 0;
    }
  }


  getrevenueRights() {
    this.ticketIssuanceService.CheckTktPnrRightsAgainstAgencyAndUserId(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data2) => {
      this.tktPnrRight = data2;

    });
  }
  statusSave(status, revenueid) {

    this.revenueService.SaveStatusListRevenue(status, revenueid, localStorage.getItem("UserId")).subscribe((data) => {
   
    });
  }
  // This method is used to check the rights of user for revenue management and those who have this right will be able to see the revenues;
  CheckRevenueManagementRights() {
    this.revenueService.CheckRightsAgaintAgencyAndUserId(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data) => {
      if (data) {
        this.right = true;
      }
      else {
        this.right = false;
      }
    });
  }
  // This method is used to check the rights of user for edit or add the revenue management and those who have this right will be able to edit or add the revenues;
  CheckCanEditRevenueRights() {
    this.revenueService.canEditRevenue(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data) => {
      this.canEditOrAddRevenue = data;
    });
  }
  DeleteRevenue(revenueId: number) {
    this.selectedRevenueId = revenueId;
    this.showDeleteModal = true;
  }
  confirmDelete() {

    if (!this.selectedRevenueId) return;

    this.revenueService.deleteRevenue(this.selectedRevenueId).subscribe((data) => {

      if (data) {

        this.revenueManagerList =
          this.revenueManagerList.filter(x => x.revenueId !== this.selectedRevenueId);

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Revenue deleted successfully'
        });

      } else {

        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Unable to delete revenue'
        });

      }

      this.showDeleteModal = false;
      this.selectedRevenueId = null;

    });
  }
  cancelDelete() {
    this.showDeleteModal = false;
    this.selectedRevenueId = null;
  }
  LoadAgencyList() {
    try {
      this.revenueService.GetRevenueManagementList(this.fromLocalStorage, this.agency).subscribe((data) => {
        this.revenueManagerList = data;

      });
    }
    catch (e) {
    }
  }

  Edit_Click(data) {
    try {
      if (data.requestType == "Ticket Revenue") {
        localStorage.setItem('RevenueManagementListId', data.revenueId);
        localStorage.setItem('RevenueType', "Ticket");
        this.router.navigateByUrl('/revenueManagement');
      }
      else if (data.requestType == "Void Revenue") {
        localStorage.setItem('RevenueManagementListId', data.revenueId);
        localStorage.setItem('RevenueType', "Void");
        this.router.navigateByUrl('/revenueManagement');
      }
      else if (data.requestType == "Refund Revenue") {
        localStorage.setItem('RevenueManagementListId', data.revenueId);
        localStorage.setItem('RevenueType', "Refund");
        this.router.navigateByUrl('/revenueManagement');
      }
      else if (data.requestType == "ImportPNR Revenue") {
        localStorage.setItem('RevenueManagementListId', data.revenueId);
        localStorage.setItem('RevenueType', "ImportPNR");
        this.router.navigateByUrl('/importRevenue');
      }
      
    }
    catch (e) { }
  }
  addnew(str:string) {
    try {
      if (str == "Ticket") {
        localStorage.setItem('RevenueType', "Ticket");
        this.router.navigateByUrl('/revenueManagement');
      }
      else if (str == "Void") {
        localStorage.setItem('RevenueType', "Void");
        this.router.navigateByUrl('/revenueManagement');
      }
      else if (str == "Refund") {
        localStorage.setItem('RevenueType', "Refund");
        this.router.navigateByUrl('/revenueManagement');
      }
      else if (str == "ImportPNR") {
        localStorage.setItem('RevenueType', "ImportPNR");
        this.router.navigateByUrl('/importRevenue');
      }     

    }
    catch (e) { }
  }
  AddNew() {
    try {
      this.router.navigateByUrl('/revenueManagement');
    }
    catch (e) { }

  }
  onCellPrepared(e) {
    if (e.rowType === "data" && e.column.dataField === "requestType") {
      /* #7df481 */

      if (e.data.requestType === "Ticket Revenue") {
        e.cellElement.style.color = "Green";
        e.cellElement.style.fontWeight = "700";
      }
      if (e.data.requestType === "Void Revenue") {
        e.cellElement.style.color = "Red";
        e.cellElement.style.fontWeight = "700";
      }
      if (e.data.requestType === "Refund Revenue") {
        e.cellElement.style.color = "Blue";
        e.cellElement.style.fontWeight = "700";
      }
      if (e.data.requestType === "ImportPNR Revenue") {
        e.cellElement.style.color = "Orange";
        e.cellElement.style.fontWeight = "700";
      }
      // Tracks the `Amount` data field
      //e.watch(function () {
      //  return e.data.requestType;
      //}, function () {
      //  e.cellElement.style.color = e.data.requestType = "Offline Ticket Request" ? "green" : "red";
      //})
    }
  }
}
